import { handleApiErrors } from '../../../../../core/data-access/http-client/interceptors/error.interceptor';
import { CreateUpdateUserComponent } from '../create-update-user/create-update-user.component';
import { SharedTableComponent } from '../../../../../../trash/shared/components/shared-table/shared-table.component';
import { ErrorOrError } from '../../../../../core/results/error-or/models/error-or-error.model';
import { IUserResponse, UsersListApiResponse } from '../../dtos/responses/users-list-response';
import { ToastService } from '../../../../../../trash/shared/components/toasters/Toast.service';
import { BaseComponent } from '../../../../../../trash/shared/components/base/base.component';
import { SahredConstants } from '../../../../../../trash/shared/constants/Values';
import { UsersService } from '../../services/users.service';
import { Subscription, tap, catchError, finalize } from 'rxjs';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { ChangeDetectorRef, Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { SkeletonModule } from 'primeng/skeleton';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { UserManagementPermissions } from '../../../../common/permissions/user-management.permissions';
import { UserContextService } from '../../../../auth-management/authentication/services/user-context.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IMenuItemAction } from '../../../../../core';

@Component({
  selector: 'app-users-list',
  standalone: true,
  imports: [
    SkeletonModule,
    CommonModule,
    RouterModule,
    ButtonModule,
    MenuModule,
    SharedTableComponent,
    TranslateModule
  ],
  templateUrl: './users-list.component.html',
  styleUrl: './users-list.component.scss',
  providers: [DialogService]
})
export class UsersListComponent extends BaseComponent<any> {
  private subscriptions: Subscription[] = [];

  UsersRes: UsersListApiResponse | null = null;
  totalItemCount: number = 0;
  isLoadingItems: boolean = false;
  isLoadingFilter: boolean = false;
  searchTerm: string | null = null;

  items = {
    headers: [
      'GENERAL.FIRST_NAME',
      'GENERAL.LAST_NAME',
      'GENERAL.EMAIL',
      'USER_MANAGEMENT.ACCOUNT',
      'USER_MANAGEMENT.SPECIALIZED_ROLES',
      'USER_MANAGEMENT.SYSTEM_ROLES',
      'GENERAL.ACTIONS'
    ],
    data: [] as IUserResponse[],
    dataKeys: ['firstName', 'lastName', 'email', 'englishName', 'specializedRoles', 'systemRoles', 'action']
  };

  viewItem: boolean = UserContextService.hasPermission(UserManagementPermissions.Users.Read);
  addItem: boolean = false;

  actionsList: IMenuItemAction[] = [];

  constructor(
    private _usersService: UsersService,
    private toastService: ToastService,
    private dialog: DialogService,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {
    super();
  }

  override ngOnInit(): void {
    this.actionsList = [
      ...(this.viewItem
        ? [
          {
            label: this.translate.instant('ACTIONS.VIEW'),
            icon: 'pi pi-eye',
            command: (event: any) => {
              this.openUserDialog(event, false);
            },
            isView: this.viewItem
          }
        ]
        : [])
    ];
    this.list(true);
  }

  // Start Get Listing Functions
  async list(filter?: boolean) {
    this.HandelRenderingDataMessage = 'GENERAL.LOADING';
    filter ? (this.isLoadingFilter = true) : (this.isLoadingItems = true);
    let RolesSubscription: Subscription = (await this._usersService.getAll(this.request))
      .pipe(
        tap((res: UsersListApiResponse) => this.processListResponse(res)),
        catchError((errors: ErrorOrError[]) => handleApiErrors(errors, this.toastService)),
        finalize(() => this.finalizeListRequest())
      )
      .subscribe();

    this.subscriptions.push(RolesSubscription);
  }
  private processListResponse(response: UsersListApiResponse): void {
    if (response) {
      this.UsersRes = response;
      this.totalItemCount = response.paginationMetadata.totalItemCount ?? 0;
      this.items.data = this.UsersRes.items;
      if (this.UsersRes.items.length == 0) {
        this.HandelRenderingDataMessage = 'GENERAL.NO_DATA_FOUND';
      }
      this.cdr.markForCheck();
    } else {
      this.HandelRenderingDataMessage = 'GENERAL.NO_DATA_FOUND';
    }
  }
  private finalizeListRequest(): void {
    this.isLoadingItems = false;
    this.isLoadingFilter = false;
  }
  //  End Get Listing Functions

  openUserDialog(item?: IUserResponse | null, visible?: boolean) {
    let headerTitle: string;
    if (visible == false) {
      headerTitle = this.translate.instant('USER_MANAGEMENT.USER_DETAILS');
    } else {
      headerTitle = `${item ? this.translate.instant('ACTIONS.EDIT') : this.translate.instant('GENERAL.CREATE')} ${this.translate.instant('GENERAL.USER')}`;
    }
    const ref: any = this.dialog.open(CreateUpdateUserComponent, {
      data: {
        item: item,
        visible: visible
      },
      header: headerTitle,
      styleClass: 'responsive-dialog-width'
    });
    ref?.onClose.subscribe((item?: any) => {
      if (item) {
        this.list();
      }
    });
  }

  resetParams(): void {
    this.page = 1;
    this.request.page = SahredConstants.INITIAL_PAGE_INDEX;
    this.request.pageSize = SahredConstants.INITIAL_PAGE_SIZE;
    this.searchTerm = null;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      if (subscription && !subscription.closed) {
        subscription.unsubscribe();
      }
    });
  }
}
